import React, { Suspense } from "react"

import Header from "organisms/common/Header"
import SnackbarWrapper from "organisms/common/SnackbarWrapper"
import Footer from "organisms/common/Footer"
import Loading from "organisms/common/Loading"
import APILoading from "organisms/common/APILoading"
import CssBaseline from "@material-ui/core/CssBaseline"

import useDAuth from "hooks/useDAuth"
import useApiLoading from "hooks/useApiLoading"
import TimeoutModal from "organisms/common/TimeoutModal"

const DefaultTemplate = ({ children }) => {
  const { isAuthLoading } = useDAuth()
  const { isApiLoading } = useApiLoading()

  return (
    <>
      <Header />
      <CssBaseline />
      <Suspense fallback={<Loading />}>
        {isAuthLoading ? <Loading /> : children}
      </Suspense>
      {isApiLoading ? <APILoading /> : null}
      <SnackbarWrapper />
      <TimeoutModal />
      <Footer />
    </>
  )
}

export default DefaultTemplate
